import React from 'react';
import { XIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const problems = ['Te da vergüenza hacer preguntas básicas porque sentís que a esta altura ya deberías entender de plata.', 'Mentorías privadas que arrancan en $500 USD — una barrera enorme cuando recién empezás.', 'Un gasto inesperado aparece y sentís que golpea más fuerte porque no tenés un respaldo armado.', 'Ves consejos por todos lados, pero nadie te explica por dónde empezar de forma simple.', 'Tenés ganas de hacer algo con tu plata, pero el miedo a equivocarte te deja quieto.'];
export function ProblemSection() {
  return <Section className="bg-ink-950" data-id="element-190" data-mp="3jf0q4w3q0cu2">
      <Reveal data-id="element-191" data-mp="3jdzbkhnhx87l">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-192" data-mp="3egz72b6aodil">
          No saber de plata no te hace llegar tarde. Te hace falta un buen punto de partida.
        </h2>
        <p className="mt-4 text-base text-gray-400 sm:text-lg" data-id="element-193" data-mp="1k3hj4n1z9en1">
          Si venís postergándolo hace tiempo, probablemente te hayas encontrado con esto:
        </p>
      </Reveal>

      <ul className="mt-8 space-y-3" data-id="element-194" data-mp="obygiirm7gp9">
        {problems.map((p, i) => <Reveal key={p} delay={i * 0.06} data-id="element-195" data-mp="ocg7p0zf74qb" data-mpi={i}>
            <li className="flex items-start gap-3 rounded-xl border border-white/5 bg-ink-900 p-4" data-id="element-196" data-mp="sd9x5ysigrlb">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-red-500/10" data-id="element-197" data-mp="x51q2fz539em">
                <XIcon className="h-4 w-4 text-red-400" data-id="element-198" data-mp="122jq1gv6ieah" />
              </span>
              <span className="text-sm text-gray-300 sm:text-base" data-id="element-199" data-mp="1726dsk8mvcxj">{p}</span>
            </li>
          </Reveal>)}
      </ul>

      <Reveal delay={0.1} data-id="element-200" data-mp="1c2u5l84orxst">
        <p className="mt-8 border-l-2 border-brand pl-5 text-base font-medium leading-relaxed text-gray-200 sm:text-lg" data-id="element-201" data-mp="1c2kaj64sb0g9">
          No se trata de hacerte rico de un día para el otro. Se trata de entender cómo empezar, construir el hábito de invertir con tiempo y llegar a tus próximos planes — o a un imprevisto — con más respaldo.
        </p>
      </Reveal>
    </Section>;
}